import { Component, input, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCopy } from '@ng-icons/lucide';

@Component({
  selector: 'gs-group-link-url-cell',
  imports: [NgIcon],
  viewProviders: [provideIcons({ lucideCopy })],
  template: `
    <button type="button" class="url-copy-cell" (click)="copied.emit()">
      <span class="url-text">{{ display() }}</span>
      <ng-icon name="lucideCopy" class="copy-icon" title="Copy to clipboard" />
    </button>
  `,
  styles: [
    `
      .url-copy-cell {
        align-items: center;
        background: none;
        border: 0;
        color: inherit;
        cursor: pointer;
        display: flex;
        font: inherit;
        gap: 0.5rem;
        padding: 0;
        text-align: left;
      }

      .copy-icon {
        flex-shrink: 0;
        opacity: 0.6;
      }

      .url-copy-cell:hover .copy-icon {
        opacity: 1;
      }
    `,
  ],
})
export class GroupLinkUrlCellComponent {
  readonly display = input('');

  readonly copied = output<void>();
}
